const tripDetails = {
    tripNotFound: 'Reis Niet Gevonden',
    tripNotFoundDescription: 'De reis die je zoekt bestaat niet.',
    backToHome: 'Terug naar Home',
    overview: 'Overzicht',
    itinerary: 'Route',
    faqs: 'Veelgestelde Vragen',
    searchFaqs: 'Zoek in vragen en antwoorden...',
    searchResults: '{count} vragen gevonden voor "{term}"',
    noSearchResults: 'Geen resultaten gevonden voor "{term}"',
    map: 'Kaart',
    bookThisTrip: 'Boek Deze Reis',
    expandAll: 'Alles Uitklappen',
    whatDoWeDo: 'Wat We Doen',
    day: 'Dag',
    sendEnquiry: 'Verstuur Verzoek',
    tripName: 'Reisnaam: *',
    enterYourName: 'Voer je naam in *',
    enterYourEmail: 'Voer je e-mail in *',
    chooseCountry: 'Kies een land *',
    selectCountry: 'Selecteer een land',
    enterContactNumber: 'Voer je telefoonnummer in *',
    directions: 'Routebeschrijving',
    viewLargerMap: 'Bekijk Grotere Kaart',
    interactiveGoogleMap: 'Interactieve Google Kaart',
    googleMapFor: 'Google Kaart voor',
    edit: 'Bewerken',
    location: 'Locatie',
    only: 'Alleen',
    days: 'Dagen',
    nights: 'Nachten',
    doYouWantToBook: 'Wil je deze reis boeken?',
    sendUsMessage: 'Stuur ons een bericht via het formulier',
    availableDates: 'Beschikbare Datums',
    breadcrumbTrips: 'Reizen',
    breadcrumbProducts: 'Producten',
    youCanSendEnquiry: 'Je kunt je verzoek versturen via het formulier hieronder.',
    countryItaly: 'Italië',
    countryGermany: 'Duitsland',
    countryFrance: 'Frankrijk',
    countrySpain: 'Spanje',
    reviews: 'beoordelingen'
};

export default tripDetails;

